export const enum EKinematicViewMode {
  Status = 'STATUS',
  Information = 'INFORMATION',
  Connected = 'CONNECTED'
}
